import React from "react";
import { Avatar, Button, Card, CircularProgress, makeStyles, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import UserInfo from "../../model/userInfo";


const useStyles = makeStyles((theme) => ({
    avatarLoading: {
        width: "130px",
        height: "130px",
        position: "relative",
        left: "-50%",
        top: "44px",
    },
    centerHorizontal: {
        marginLeft: "auto",
        marginRight: "auto",
    },
    textCenter: {
        textAlign: "center",
    },
    loading: {
        marginTop: "40%",
        position: "relative",
        top: "-26px",
        left: "-50%",
        minWidth: "150px",
    },
    flex1: {
        flexGrow: 1,
    },
    info: {
        position: "relative",
        width: "100%",
    },
    marginTop2: {
        marginTop: "2rem",
    },
    marginTop3: {
        marginTop: "3rem",
    },
    bold: {
        fontWeight: "bold",
    },
    blackButton: {
        backgroundColor: theme.palette.primary.main,
        "&:hover": {
            background: theme.palette.primary.main,
        },
        width: "max(50%,200px)",
        margin: "0 auto",
        display: "block",
    },
    loadingContainer: {
        position: "absolute",
        left: "50%",
    },
    infoContainer: {
        marginTop: "40vh",
    },
}));

type WaitingScreenProps = {
    user: UserInfo;
    backButton: boolean,
}

export default function DefinedWaitingOpponent({ user, backButton }: WaitingScreenProps): JSX.Element {
    const classes = useStyles();
    const { t } = useTranslation();
    const history = useHistory();

    const button = !backButton ? null : (
        <Button
            color="primary"
            className={`${classes.blackButton} ${classes.marginTop3}`}
            onClick={() => history.replace("/")}
        >
            <Typography variant="h4" color="secondary">
                {t("replay.cancel")}
            </Typography>
        </Button>
    );

    return (
        <Card elevation={0} className={`${classes.centerHorizontal} ${classes.info} ${classes.flex1}`}>
            <div className={`${classes.loadingContainer}`}>
                <CircularProgress size={150} className={classes.loading} />
            </div>
            <div className={`${classes.loadingContainer}`}>
                <Avatar
                    alt={user.name}
                    src={user.image}
                    className={`${classes.avatarLoading}`}
                />
            </div>
            <div className={`${classes.infoContainer}`}>
                <Typography variant="h3" className={`${classes.centerHorizontal} ${classes.textCenter} ${classes.marginTop2}`}>
                    {t("A espera de")}
                </Typography>
                <Typography variant="h3" className={`${classes.centerHorizontal} ${classes.textCenter} ${classes.bold}`}>
                    {user.username}
                </Typography>
                {button}
            </div>
        </Card>
    );
}
